// Config

// Components
import moment from "moment";
import { useClients } from "../../contexts/ClientsContext";
import { AvisosContainer } from "./styles";
import { ChoosePlanStep } from "../UserPlanModal/ChoosePlanStep";
import { useEffect, useState, memo } from "react";
import { usePlanVerification } from "../../hooks/usePlanVerification";
import { Button, Typography } from "antd";
import { FiArrowRight } from "react-icons/fi";
import { AiOutlineLink } from "react-icons/ai";
import { BiX } from "react-icons/bi";
import api from "../../services/api";
import { useAuth } from "../../contexts/AuthContext";
import { Planos } from "../Planos";
// Assets

// Types
interface IProps {
  selectedPlan: any;
  setSelectedPlan: any;
  setPaymentType: any;
  clientsWithCancelRecurring: any;
  setShowPaymentModal: any;
  setOpen: any;
  setIntegrationModal: any;
  setIntegrationClient: any;
  setClientsSelected: any;
  filters?: any
}

const AvisosComponent = ({
  selectedPlan,
  setSelectedPlan,
  setPaymentType,
  clientsWithCancelRecurring,
  setShowPaymentModal,
  setOpen,
  setIntegrationClient,
  setIntegrationModal,
  setClientsSelected,
  filters
}: IProps) => {
  const { selectedClient, setClients, getClients } = useClients();
  const [dismissBolsa, setDismissBolsa] = useState(false);
  const [dismissExterior, setDismissExterior] = useState(false);
  const planBought = selectedClient?.userPlanInfoVelotax?.type ?? "";
  const isCancelRecurring = (clientsWithCancelRecurring || []).length > 0;

  useEffect(() => {
    setDismissBolsa(false);
    setDismissExterior(false);
  }, [selectedClient]);

  const closeIntegration = async (type: "bolsa" | "exterior") => {
    try {
      if (type === "bolsa") {
        setDismissBolsa(true);
      } else {
        setDismissExterior(true);
      }
      await api.put("/clients/close-integration", {
        cpf: selectedClient?.username,
        type,
      });
      setClients((clients: any[]) =>
        clients.map((client) => ({
          ...client,
          closeIntegrationBolsa:
            client.username === selectedClient?.username && type === "bolsa"
              ? true
              : client.closeIntegrationBolsa,
          closeIntegrationExterior:
            client.username === selectedClient?.username && type === "exterior"
              ? true
              : client.closeIntegrationExterior,
        }))
      );
    } catch (err) {}
  };

  // Usar hook otimizado para verificação de planos
  const { hasPlan: temPlano, temIntegracaoBolsa, temIntegracaoExterior } = usePlanVerification(selectedClient);

  return (
    <AvisosContainer
      temPlano={temPlano}
      liberadaContratacao={false}
      className={!temPlano ? "client-details" : ""}
    >
      <div>
        {
          !temPlano && (
           <Planos hasPlan={false} selectedClient={selectedClient} filters={filters}/>
          )
        }
        {temPlano &&
          !temIntegracaoBolsa &&
          !dismissBolsa &&
          !selectedClient?.closeIntegrationBolsa && (
            <div className="client-integration-card">
              <AiOutlineLink />
              <div className="client-integration-card-content">
                <Typography.Title level={3}>
                  Integração com bolsa pendente
                </Typography.Title>
                <Typography.Paragraph>
                  O seu cliente deve conceder a permissão na B3 para que seja
                  possível acessar suas operações da bolsa de valores de forma
                  automática.
                </Typography.Paragraph>
                <Button
                  type="link"
                  onClick={() => {
                    setIntegrationModal("B3");
                    setIntegrationClient(selectedClient);
                  }}
                >
                  Saiba mais
                  <FiArrowRight />
                </Button>
              </div>
              <BiX
                className="dismiss"
                onClick={() => closeIntegration("bolsa")}
              />
            </div>
          )}
        {/* {temPlano &&
          !temIntegracaoExterior &&
          !dismissExterior &&
          !selectedClient?.closeIntegrationExterior && (
            <div className="client-integration-card">
              <AiOutlineLink />
              <div className="client-integration-card-content">
                <Typography.Title level={3}>
                  Conecte com a XP International
                </Typography.Title>
                <Typography.Paragraph>
                  O seu cliente deve conceder a permissão na XP International
                  para que seja possível acessar suas operações no exterior de
                  forma automática.
                </Typography.Paragraph>
                <Button
                  type="link"
                  onClick={() => {
                    setIntegrationModal("XP International");
                    setIntegrationClient(selectedClient);
                  }}
                >
                  Saiba mais
                  <FiArrowRight />
                </Button>
              </div>
              <BiX
                className="dismiss"
                onClick={() => closeIntegration("exterior")}
              />
            </div>
          )} */}
      </div>
    </AvisosContainer>
  );
};

// Memoizar o componente para evitar re-renders desnecessários
export const Avisos = memo(AvisosComponent);
